import userEditedRecordStore from "data/userEditedRecordStore";
import lockStore from "data/lockStore";

const hasUnsavedChanges = fluxContextOrNull => {
    if (fluxContextOrNull) {
        const optlock = lockStore.getOptLock(fluxContextOrNull);
        return userEditedRecordStore.hasEdits(fluxContextOrNull) && (!optlock || !optlock.violated);
    } else {
        return userEditedRecordStore.getContextNames().some(it =>
            it && hasUnsavedChanges(it));
    }
};

export default hasUnsavedChanges;



// WEBPACK FOOTER //
// ./app/data/selectors/hasUnsavedChanges.js